import { useState, useEffect, useLayoutEffect } from 'react';
function useReactDomsReady(callbackFunction) {
    if (callbackFunction === void 0) { callbackFunction = function () {
        console.warn("You need a callbackFunction in order to use this hook");
    }; }
    var _a = useState(false), isReactDomReady = _a[0], setIsReactDomReady = _a[1];
    var _b = useState(false), isCallbackFunctionCalled = _b[0], setFunctionCalled = _b[1];
    var refreshReactDomState = function () {
        var drupalDomReadyValue = sessionStorage.getItem('drupalDomReady');
        var isDrupalDomReady = drupalDomReadyValue === 'true' || drupalDomReadyValue === null;
        setIsReactDomReady(isDrupalDomReady);
    };
    useEffect(function () {
        if (isReactDomReady) {
            if (!isCallbackFunctionCalled) {
                callbackFunction();
                setFunctionCalled(true);
            }
        }
    }, [isReactDomReady]);
    useLayoutEffect(function () {
        refreshReactDomState();
        document.addEventListener('drupalDomChanged', function (e) {
            refreshReactDomState();
        });
    }, []);
    return { ready: isReactDomReady };
}
export default useReactDomsReady;
